import { atomEffect } from 'jotai-effect';
import type { Atom } from 'jotai';
import { SocketConnectionWorker } from '../../../components/SocketConnection/CreateWorker';
import { EVENT_USER_DRIVERS } from '../../../components/SocketConnection/constants';
import { getUserId } from '../../../Services/UserService';

const isPromise = <T>(value: unknown): value is Promise<T> =>
  typeof value === 'object' && value !== null && 'then' in value;

function sendToSocket(driverIds: number[]) {
  const data = {
    event: EVENT_USER_DRIVERS,
    payload: driverIds,
    userId: getUserId(),
  };
  SocketConnectionWorker.postMessage(data);
}

export const setDriverIdsToSocketServerEffect = (sourceAtom: Atom<number[] | Promise<number[]>>) =>
  atomEffect((get) => {
    const newValue = get(sourceAtom);

    if (isPromise<number[]>(newValue)) {
      newValue.then((resolvedValue) => sendToSocket(resolvedValue));
    } else {
      sendToSocket(newValue);
    }
  });
